<template>
  <div v-if="status" class="badge" :class="badgeClass">{{ badgeText }}</div>
</template>

<script>
export default {
  name: 'FeatureBadge',
  props: {
    status: {
      type: String,
      required: true,
    },
  },
  computed: {
    badgeText() {
      if (this.status == '') {
        return null;
      }

      return this.$t(`features.status.${this.status}`);
    },
    badgeClass() {
      if (this.status == 'C') {
        return 'badge-primary';
      }
      if (this.status == 'N') {
        return 'badge-success';
      }
      if (this.status == 'S') {
        return 'badge-danger';
      }
      return 'badge-primary';
    },
  },
};
</script>

<style></style>
